module.exports = __webpack_public_path__ + "img/1530965248.82c6c55a.jpg";